const call_restaurant = `Hello, I would like to make a reservation for dinner for three people this weekend. 
Could you please let me know if you have availability on Friday at 8pm? 
When does the restuarant close after dinner?.
Also how much would it cost for 3 people.
Thank you.`;

export default call_restaurant;